import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import commonUtil from './../../utils/commonUtil';

import GiftListTableFilters from './components/GiftListTableFilters';
import GiftSummaryTable from './components/GiftSummaryTable';
import ApplyCSS from '../../components/ApplyCSS';
import Tagging from '../../components/Tagging/Tagging';

import * as AccountStatusDetailsAction from '../BrowseAndNavigate/AccountSummary/actions';
import { getEventSummaryInfo } from '../eventManagement/page/GiftList/actions';

import * as labelsActions from '../../components/labels/actions';
import GiftSummaryTableWap from './components/GiftSummaryTableWap';

import * as EventCategoryActions from '../../components/eventcategory/actions';

import { setGiftListTransferenceStatementTab } from '../eventManagement/page/GiftList/actions';

import { updateGiftListHeader } from '../../components/globleObject/actions';

import Warning2 from '../../components/Warning2';

const { getPurchasedItemSummaryInfo, getPurchasedItemsDetails, getStatementDetailsForPrintAndDownload } = AccountStatusDetailsAction;
const { isLablesLoaded, loadLables } = labelsActions;

const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isEventCategoryLoaded(getState())) {
      return dispatch(loadEventCategoryEvent());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  eventDetails: store.eventDetail.data,
  eventCategory: store.eventcategory.data,
}),
  { labelsActions, setGiftListTransferenceStatementTab, updateGiftListHeader })

class GiftListTableSummary extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isPhysical: false,
        isElectronic: false,
        isPersonal: false,
        pageType: '',
        selectedTheme: {},
        sortingParameters: [{type: "date", value: "descending"}],
        filteringParameters: [],
        filteringParametersForCount: [],
        eventDaysleft: 0,
        initialPurchasedItemsDetailsData: {},
      };
      this.summaryInfoResponse = '';
      this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    }
    
    componentDidMount() {
      commonUtil.addTransition();
      const pathname = window.location.pathname;
      const isPhysical = pathname.includes('/resumendelacuenta/regalosfisicos/');
      const isElectronic = pathname.includes('/resumendelacuenta/regalodeelectronica/'); 
      const isPersonal = pathname.includes('/resumendelacuenta/compraspersonales/');

      this.props.updateGiftListHeader("Statements Table Pages");

      let url = this.props.route.path.split('(');
      url = url[0];
    
      let cdSection = isPhysical ? 'Regalos físicos' : isElectronic ? 'Regalo de electrónica' : isPersonal ? 'Compras personales' : '';
      // eslint-disable-next-line no-undef
      dataLayer.push({
        event: 'vPageView',
        GroupOne: url,
        actURL: window.location.pathname,
        actPageTitle: document.title,
        cdSection: cdSection,
        Site: 'Mesa de Regalos',
        idMesa: this.eventId,
      });

      let pageType = '';

      if(isPhysical){
        pageType = 'physical';
      }else if(isElectronic){
        pageType = 'electronic';
      }else if(isPersonal){
        pageType = 'personal';
      }

      let eventIdDetails = this.props?.eventDetails?.eventList?.find((eventObj) => eventObj.eventId == this.eventId);

      let eventData = _.find(this.props?.eventCategory?.eventConfigurations,['name', eventIdDetails?.eventType || ''])
      let themeData = _.find(eventData.event_themes,["uid", eventIdDetails?.eventTheme])

      this.props.getStatementDetailsForPrintAndDownload(this.eventId);
      this.props.getPurchasedItemSummaryInfo(this.eventId, pageType);
      if (channel === constChannels.WAP) {
        this.props.getPurchasedItemsDetails(this.eventId, pageType, [], this.state.sortingParameters, '1', true).then((res) => {
          if (res && res.status && res.status?.status === 'success') {
            this.setState({ initialPurchasedItemsDetailsData: res });
          }
        });
      } else {
        this.props.getPurchasedItemsDetails(this.eventId, pageType, [], this.state.sortingParameters, '1', false);
      }
      if (!_.isEmpty(this.props.state.user.data) && !_.isEmpty(this.props.state.user.data.result)) {
        this.props.getEventSummaryInfo(this.eventId, this.props.state.user.data.result.profileId, this.props.state.user.data.result.emailId).then((response) => {
          if (response && response.status?.status === 'success') {
            this.summaryInfoResponse = response;
            let eventDaysleft = this.getDaysLeft(response?.eventInfo?.eventDate);
            this.setState({eventDaysleft});
          }
        }).catch((e) => { console.log(e); });
      }

      this.setState({
          isPhysical,isElectronic,isPersonal,pageType,
          selectedTheme: themeData || {
            "color_50": "#E9EBF8",
            "color_100": "#C0C0C0",
            "color_200": "#A1A1A1",
            "color_300": "#767676",
            "color_400": "#5C5C5C",
            "color_500": "#333333",
            "color_600": "#2E2E2E",
            "color_700": "#242424",
            "color_800": "#1C1C1C",
            "color_900": "#151515",
          }
      })
    }

    componentWillUnmount() {
      if (document.body.classList.contains('body-no-scroll')) {
        document.body.classList.remove('body-no-scroll');
      }
    }

    handleFilterParametersChange = (filteringParameters, filtersForCount) => {
      if(filtersForCount){
        this.setState({ filteringParametersForCount: filteringParameters });
      }else{
        this.setState({ filteringParameters: filteringParameters });
      }
    }
    
    getFilterSorted = (filteringParameters, sortingParameters, currentPage, isShowAll, isRemoveAll) => {
      this.setState({ sortingParameters: sortingParameters, filteringParameters: filteringParameters});
      if(isRemoveAll){
        this.setState({ filteringParametersForCount: [] });
      }
      this.props.getPurchasedItemsDetails(this.eventId, this.state.pageType, filteringParameters, sortingParameters, currentPage.toString(), isShowAll);
    }

    getDaysLeft = (eventDateStr) => {
      const eventDate = new Date(eventDateStr);
      const currentDate = new Date();
    
      eventDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
    
      const diffTime = eventDate - currentDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
      return diffDays;
    }

    showMessagePopUp = (success,customMessage,showCloseIcon=true) => {
      window.scrollTo({
        top: 0, 
        behavior: "smooth",
      });
    
      if(success && customMessage){
        this.warning.setMessage(customMessage,showCloseIcon);
      } else {
        this.errorMessage.setMessage(customMessage ? customMessage : commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailfailed.message'),showCloseIcon);
      }
    }
    
    render() {
      const { isPhysical,isElectronic,isPersonal, } = this.state;

      const bonusDetails = this.props.statementDetailsForPrintAndDownloadData?.accountStatementInfo?.bonusDetails;

      let bonusPercentage = bonusDetails?.bonusPercentage || 0;

      const isBonusContainerVisible = (bonusPercentage != 0) ? true : false;

      let warningWidth = '1200px';

      const succesWarning = <Warning2
        type="success"
        text={this.warningMessage}
        ref={(warning) => (this.warning = warning)}
        style={{
          position: 'absolute',
          width: (channel === 'web') ? warningWidth : '92%',
          top: (channel === 'web') ? '2px' : '171px',
          left: (channel === 'web') ? 'unset' : '4%',
          zIndex: 999,
        }}
        notSetToTop={true}
        onClose={false}
      />

      const errorWarning = <Warning2
        type="error"
        text={this.errorMessage}
        ref={(errorMessage) => (this.errorMessage = errorMessage)}
        style={{
          position: 'absolute',
          width: (channel === 'web') ? warningWidth : '92%',
          top: (channel === 'web') ? '2px' : '171px',
          left: (channel === 'web') ? 'unset' : '4%',
          zIndex: 999,
        }}
        notSetToTop={true}
        onClose={false}
      />

      return (
        <>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName="giftList" />
            {channel === 'web' ?
                <div className='gift-list-table-summary-container'>
                    {succesWarning}
                    {errorWarning}
                    <div className='gift-filter-table-summary-container'>
                        <GiftListTableFilters 
                          ref={giftListTableFiltersWEB => this.giftListTableFiltersWEB = giftListTableFiltersWEB}
                          isPhysical={isPhysical} 
                          isElectronic={isElectronic} 
                          isPersonal={isPersonal} 
                          channel={channel}
                          purchasedItemSummaryInfoData={this.props.purchasedItemSummaryInfoData}
                          purchasedItemsDetailsData={this.props.purchasedItemsDetailsData}
                          getFilterSorted={this.getFilterSorted}
                          accountStatus={this.props.accountStatus}
                          lables={this.props.lables}
                          eventId={this.eventId}
                          user={this.props.user}
                          eventInfo={this.props.eventInfo}
                          statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                          printingDate={this.props.printingDate}
                          selectedTheme={this.state.selectedTheme}
                          sortingParameters={this.state.sortingParameters}
                          filteringParameters={this.state.filteringParameters}
                          isBonusContainerVisible={isBonusContainerVisible}
                        />
                        <GiftSummaryTable
                          ref={giftSummaryTableWEB => this.giftSummaryTableWEB = giftSummaryTableWEB}
                          isPhysical={isPhysical} 
                          isElectronic={isElectronic} 
                          isPersonal={isPersonal} 
                          channel={channel}
                          purchasedItemSummaryInfoData={this.props.purchasedItemSummaryInfoData}
                          purchasedItemsDetailsData={this.props.purchasedItemsDetailsData}
                          getFilterSorted={this.getFilterSorted}
                          accountStatus={this.props.accountStatus}
                          lables={this.props.lables}
                          eventId={this.eventId}
                          user={this.props.user}
                          eventInfo={this.props.eventInfo}
                          statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                          printingDate={this.props.printingDate}
                          selectedTheme={this.state.selectedTheme}
                          sortingParameters={this.state.sortingParameters}
                          filteringParameters={this.state.filteringParameters}
                          isBonusContainerVisible={isBonusContainerVisible}
                          eventDaysleft={this.state.eventDaysleft}
                          setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                          showMessagePopUp={this.showMessagePopUp}
                        />
                    </div>            
                </div>
            :
            <>
                {succesWarning}
                {errorWarning}
                <GiftSummaryTableWap
                  ref={giftSummaryTableWAP => this.giftSummaryTableWAP = giftSummaryTableWAP}
                  isPhysical={isPhysical} 
                  isElectronic={isElectronic} 
                  isPersonal={isPersonal} 
                  channel={channel}
                  purchasedItemSummaryInfoData={this.props.purchasedItemSummaryInfoData}
                  purchasedItemsDetailsData={this.props.purchasedItemsDetailsData}
                  initialPurchasedItemsDetailsData={this.state.initialPurchasedItemsDetailsData}
                  getFilterSorted={this.getFilterSorted}
                  handleFilterParametersChange={this.handleFilterParametersChange}
                  filteringParametersForCount={this.state.filteringParametersForCount}
                  accountStatus={this.props.accountStatus}
                  lables={this.props.lables}
                  eventId={this.eventId}
                  user={this.props.user}
                  eventInfo={this.props.eventInfo}
                  statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                  printingDate={this.props.printingDate}
                  selectedTheme={this.state.selectedTheme}
                  sortingParameters={this.state.sortingParameters}
                  filteringParameters={this.state.filteringParameters}
                  isBonusContainerVisible={isBonusContainerVisible}
                  eventDaysleft={this.state.eventDaysleft}
                  showMessagePopUp={this.showMessagePopUp}
                />
            </>
            }
        </>
        
      );
    }
}

const mapStateToProps = (state) => {
  
    return {
  state,
  user: state.user.data,
  lables: state.labels,
  eventInfo: state.accountSummary.eventInfo.eventInfo,
  accountStatus: state.accountSummary.accountStatus,
  purchasedItemSummaryInfoData: state.accountSummary.purchasedItemSummaryInfoData,
  purchasedItemsDetailsData: state.accountSummary.purchasedItemsDetailsData,
  statementDetailsForPrintAndDownloadData: state.accountSummary.statementDetailsForPrintAndDownloadData,
  printingDate: state.info && state.info.data && state.info.date.time,
}}
;

const matchDispatchToProps = dispatch => bindActionCreators({ getPurchasedItemSummaryInfo, getPurchasedItemsDetails, getEventSummaryInfo, getStatementDetailsForPrintAndDownload }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GiftListTableSummary);